module.exports = __webpack_public_path__ + "img/BAU_Partners_3.ba384f2a.jpg";